import $ from 'jquery';

const inputPatternCheck = (input, message, pattern) => {
    const match = input.val().match(pattern);
    if (match === null) {
        input[0].setCustomValidity(message);
    } else {
        input[0].setCustomValidity('');
    }
};

$('input').each(function () {
    const input = $(this);
    const pattern = input.attr('pattern');
    if (pattern !== undefined) {
        let message = input.attr('title');
        message = message || 'Incorrect field value';

        input.change(() => inputPatternCheck(input, message, pattern));
        input.keyup(() => inputPatternCheck(input, message, pattern));
    }
});

const inputPhoneCheck = (input, message) => {
    const value = input.val().replace(/[^0-9.]/g, '');
    if (value.length === 12) {
        input[0].setCustomValidity('');
    } else {
        input[0].setCustomValidity(message);
    }
};

$('.control-input--phone').each(function () {
    const input = $(this);
    let message = input.attr('title');
    message = message || 'Incorrect field value';

    input.change(() => inputPhoneCheck(input, message));
    input.keyup(() => inputPhoneCheck(input, message));
});
